import React from 'react';

const TypingText = ({ text }) => {
  return <span>{text}</span>;
};

export default TypingText;
